export const CONTACTS = "CONTACTS";
export const CONTACT_COUNT = "CONTACT_COUNT";
